module.exports = __webpack_public_path__ + "static/media/pyv-select-start.7517c908.gif";